<template>
    <Wrapper :title="$t('revoke.accountRevoke')" @on-back="$emit('on-back', $options.name)">
        <template #content>
            <h2 class="text-base mb-24">{{ $t('revoke.iosAuth') }}</h2>
            <p class="indent-2">{{ $t('revoke.iosAuthText') }}</p>
        </template>
        <template #footer>
            <van-button class="w-full" :loading="loading" @click="handleClick">
                <AppleLogo class="apple-logo" /> {{ $t('revoke.iosLogin') }}
            </van-button>
        </template>
    </Wrapper>
</template>

<script>
import Vue from 'vue';
import { Button } from 'vant';
import AppleLogo from '@/assets/svg/apple.svg';
import { revokeIOS } from '@/api/revoke';
import { Platform } from '@/enums';
import { webviewPostMessage, jsonParser } from '@/lib/utils';
import Wrapper from './Wrapper.vue';
import { Target } from '../constant';

Vue.use(Button);

export default {
    name: 'IOSRevalidate',
    components: {
        Wrapper,
        AppleLogo,
    },
    props: {
        captchaData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            code: '',
            loading: false,
        };
    },
    watch: {
        code(curr) {
            if (curr) this.appleRevokeToken(curr);
        },
    },
    methods: {
        handleClick() {
            this.loading = true;
            this.getAuthorizationCode();
        },
        callback(res) {
            const { resultCode, code } = jsonParser(res) || {};
            if (resultCode === 0) {
                this.code = code;
            } else {
                this.loading = false;
            }
        },
        getAuthorizationCode() {
            webviewPostMessage(Platform.WebView, {
                func: 'GHomeUnregisterSignInWithApple',
                callbackObj: {
                    // 分开写，解决 this 指向的问题
                    GHomeUnregisterSignInWithAppleCallback: this.callback,
                },
            });
        },
        async appleRevokeToken(code) {
            try {
                const data = await revokeIOS({
                    flowId: this.captchaData.flowId,
                    authorizationCode: code,
                });
                this.$emit('on-step', {
                    current: Target.IOSRevalidate,
                    target: Target.Success,
                    data,
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.apple-logo {
    width: auto;
    height: 20px;
    vertical-align: text-bottom;
}
</style>
